export const navigationPath = {
  HOME_PAGE: "/",
  DEV_PAGE: "/DEV",
  RAFFLE_DB_PAGE: "/raffledb",
  RAFFLE_INPUT_PAGE: "/raffleinput",
  RAFFLE_CONFIRM_PAGE: "/raffleconfirm",
  SET_LIST_PAGE: "/setlist",
  GUEST_BOOK_PAGE: "/guestbook",
}